import { courseRuntimeUrl } from './courseRuntimeContext';
import api from '../httpClient';
import type {
  QuizIntroResponse,
  QuizResponse,
  QuizResults,
  QuizStartResponse,
  QuizSubmissionResponse,
  ResponsePayload,
} from '../../types';

export const quiz = {
  submitCanonicalAttempt: (attemptId: number) =>
    api.post<QuizSubmissionResponse>(courseRuntimeUrl(`/api/quiz/submit/${attemptId}/`), {}),
  getIntro: (flowId: number) => api.get<QuizIntroResponse>(courseRuntimeUrl(`/api/quiz/intro/${flowId}/`)),
  startQuiz: (flowId: number) => api.post<QuizStartResponse>(courseRuntimeUrl(`/api/quiz/start/${flowId}/`)),
  upsertAttemptResponse: (attemptId: number, payload: ResponsePayload) =>
    api.post<ResponsePayload>(courseRuntimeUrl(`/api/quiz/attempts/${attemptId}/responses/`), payload),
  submitQuiz: (
    attemptId: number,
    responses: QuizResponse[],
    options?: { includeQuestionReview?: boolean },
  ) =>
    api.post<QuizSubmissionResponse>(courseRuntimeUrl(`/api/quiz/submit/${attemptId}/`), {
      responses,
      ...(options?.includeQuestionReview ? { include_question_review: true } : {}),
    }),
  getResults: (flowId: number) => api.get<QuizResults>(courseRuntimeUrl(`/api/quiz/results/${flowId}/`)),
  getAttempts: () => api.get(courseRuntimeUrl('/api/quiz/attempts/')),
  getAttempt: (attemptId: number) => api.get(courseRuntimeUrl(`/api/quiz/attempts/${attemptId}/`)),
  getAttemptResponses: (attemptId: number) =>
    api.get<ResponsePayload[]>(courseRuntimeUrl(`/api/quiz/attempts/${attemptId}/responses/`)),
};
